'use strict';

exports.__esModule = true;
exports.MISSION_KINDS = undefined;
exports.get = get;
exports.getById = getById;
exports.getByIdOrBarcode = getByIdOrBarcode;
exports.getHistory = getHistory;
exports.getGroupCounts = getGroupCounts;
exports.updateState = updateState;
exports.createOrder = createOrder;
exports.markReadyForCollection = markReadyForCollection;
exports.createMission = createMission;

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MISSION_KINDS = exports.MISSION_KINDS = {
  collection: '/orders/create_collection_mission',
  deliveryFromQuiqupDepot: '/orders/create_delivery_mission',
  deliveryFromClientLocation: '/orders/create_mission',
  return: '/orders/create_return_mission',
  transfer: '/orders/create_transfer_mission'
};

var API = {
  ORDERS: '/orders',
  ORDERS_ID_BARCODE: '/orders/find_by_id_or_barcode',
  GROUP_COUNTS: '/orders/group_counts',
  UPDATE_STATE: '/orders/batch'
};

var Orders = {
  get: get,
  getById: getById,
  getByIdOrBarcode: getByIdOrBarcode,
  getGroupCounts: getGroupCounts,
  updateState: updateState,
  createMission: createMission,
  getHistory: getHistory,
  createOrder: createOrder,
  markReadyForCollection: markReadyForCollection
};

function get(attrs) {
  return _apiClient2.default.get({ route: API.ORDERS, params: attrs });
}

function getById(id) {
  return _apiClient2.default.get({ route: API.ORDERS + '/' + id });
}

function getByIdOrBarcode(value, intention) {
  return _apiClient2.default.get({
    route: API.ORDERS_ID_BARCODE,
    params: { value: value, intention: intention }
  });
}

function getHistory(id) {
  return _apiClient2.default.get({ route: API.ORDERS + '/' + id + '/history' });
}

function getGroupCounts(attrs) {
  return _apiClient2.default.get({ route: API.GROUP_COUNTS, params: attrs });
}

function updateState(_ref) {
  var orderIds = _ref.orderIds,
      state = _ref.state,
      location = _ref.location;

  return _apiClient2.default.put({ route: API.UPDATE_STATE + '/set_' + state, data: { orderIds: orderIds, location: location } });
}

function createOrder(attrs) {
  return _apiClient2.default.post({ route: API.ORDERS, data: attrs });
}

function markReadyForCollection(id) {
  return _apiClient2.default.put({ route: API.ORDERS + '/' + id + '/ready_for_collection' });
}

/**
 * POST request
 * @param {string} kind - API endpoint kind
 * @param {string[]} orderIds - Array of order IDs
 * @param {string} depotName - Region code for the depot (e.g 'uae.dubai')
 * @returns {promise} containing network information and entity response
 */
function createMission(_ref2) {
  var kind = _ref2.kind,
      orderIds = _ref2.orderIds,
      depotName = _ref2.depotName;

  return _apiClient2.default.post({
    route: MISSION_KINDS[kind],
    data: {
      orderIds: orderIds,
      depotName: depotName
    }
  });
}

exports.default = Orders;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/orders/index.js
// module id = 1201
// module chunks = 0